import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect, useMemo, useState } from 'react';
import { Pressable, View } from 'react-native';
import { BLACK, BLACK_500, BLUE_500 } from '../../constants';
import { LeftChevronIcon, LeftDoubleChevronIcon, RightChevronIcon, RightDoubleChevronIcon } from '../../icons';
import { StateConfigContext } from '../../providers';
import { getTestId } from '../../utils';
import { Dropdown } from '../dropdown';
import { Typography } from '../typography';
import { getArrayWithRange, getPaginationProps, getPaginationStyles } from './PaginationStyles';
export var Pagination = props => {
  var _a, _b;
  var stateContext = useContext(StateConfigContext);
  var paginationProps = getPaginationProps(props, stateContext);
  var paginationStyles = getPaginationStyles(paginationProps);
  var dropdownLabel = paginationProps.dropdownLabel,
    _paginationProps$drop = paginationProps.dropdownList,
    dropdownList = _paginationProps$drop === void 0 ? [] : _paginationProps$drop,
    onDropdownChange = paginationProps.onDropdownChange,
    _paginationProps$sele = paginationProps.selectedDropdownIndex,
    selectedDropdownIndex = _paginationProps$sele === void 0 ? 0 : _paginationProps$sele,
    _paginationProps$page = paginationProps.pageCount,
    pageCount = _paginationProps$page === void 0 ? 0 : _paginationProps$page,
    _paginationProps$sele2 = paginationProps.selectedPageCountIndex,
    selectedPageCountIndex = _paginationProps$sele2 === void 0 ? 0 : _paginationProps$sele2,
    _paginationProps$maxN = paginationProps.maxNumberOfPagesToBeShown,
    maxNumberOfPagesToBeShown = _paginationProps$maxN === void 0 ? 5 : _paginationProps$maxN,
    onPageChange = paginationProps.onPageChange,
    style = paginationProps.style,
    testID = paginationProps.testID;
  var _useState = useState(null),
    selectedDropdownValue = _useState[0],
    setSelectedDropdownValue = _useState[1];
  var pageNumbers = Array.from({
    length: pageCount
  }, (_, i) => i + 1);
  var _useState2 = useState(selectedPageCountIndex),
    selectedPage = _useState2[0],
    setSelectedPage = _useState2[1];
  var isFirstPage = selectedPage === 0;
  var isLastPage = selectedPage === pageNumbers.length - 1;
  useEffect(() => {
    if (selectedDropdownIndex != null && (dropdownList === null || dropdownList === void 0 ? void 0 : dropdownList.length) > 0) {
      setSelectedDropdownValue(dropdownList[selectedDropdownIndex]);
    }
  }, [selectedDropdownIndex]);
  useEffect(() => {
    if (selectedPageCountIndex != null) {
      setSelectedPage(selectedPageCountIndex);
    }
  }, [selectedPageCountIndex]);
  var onPageSelectHandler = index => {
    setSelectedPage(index);
    onPageChange({
      index
    });
  };
  var updatedDropdownList = useMemo(() => {
    return dropdownList.map(item => {
      return Object.assign(Object.assign({}, item), {
        subHeading: item.label
      });
    });
  }, dropdownList);
  return _jsxs(View, Object.assign({
    style: [paginationStyles.container, style]
  }, getTestId(testID), {
    children: [(dropdownList === null || dropdownList === void 0 ? void 0 : dropdownList.length) > 0 && _jsxs(View, Object.assign({
      style: paginationStyles.leftSection
    }, {
      children: [_jsx(View, Object.assign({
        style: paginationStyles.dropdownLabel
      }, {
        children: !!dropdownLabel && _jsx(Typography, {
          text: dropdownLabel,
          type: "body-single-line-md"
        })
      })), _jsx(View, Object.assign({
        style: paginationStyles.dropdownAndInputContainer
      }, {
        children: _jsx(Dropdown, {
          filterKey: "subHeading",
          dropdownList: updatedDropdownList,
          onSelectedHandler: function onSelectedHandler() {
            for (var _len = arguments.length, dropdownSelectedHandlerArgs = new Array(_len), _key = 0; _key < _len; _key++) {
              dropdownSelectedHandlerArgs[_key] = arguments[_key];
            }
            var item = dropdownSelectedHandlerArgs[2];
            onDropdownChange === null || onDropdownChange === void 0 ? void 0 : onDropdownChange(item);
          },
          inputContainerProps: {
            caretHidden: true,
            preventOnChangeText: true
          },
          value: selectedDropdownValue === null || selectedDropdownValue === void 0 ? void 0 : selectedDropdownValue.label,
          postfixIconName: "DownChevronButtonIcon"
        })
      }))]
    })), (pageNumbers === null || pageNumbers === void 0 ? void 0 : pageNumbers.length) > 0 && _jsxs(View, Object.assign({
      style: paginationStyles.rightSection
    }, {
      children: [_jsx(Pressable, Object.assign({
        disabled: isFirstPage,
        onPress: () => onPageSelectHandler(0)
      }, {
        children: _jsx(LeftDoubleChevronIcon, {
          fontSize: 20,
          color: isFirstPage ? BLACK_500 : BLACK
        })
      })), _jsx(Pressable, Object.assign({
        disabled: isFirstPage,
        onPress: () => onPageSelectHandler(selectedPage - 1)
      }, {
        children: _jsx(LeftChevronIcon, {
          fontSize: 20,
          color: isFirstPage ? BLACK_500 : BLACK
        })
      })), _jsxs(View, Object.assign({
        style: paginationStyles.pageNumbers
      }, {
        children: [pageNumbers.length > maxNumberOfPagesToBeShown && selectedPage !== 0 && _jsxs(_Fragment, {
          children: [_jsx(Pressable, Object.assign({
            style: paginationStyles.singlePage,
            onPress: () => {
              onPageSelectHandler(0);
            }
          }, {
            children: _jsx(Typography, {
              selectable: false,
              text: (_a = pageNumbers[0]) === null || _a === void 0 ? void 0 : _a.toString(),
              type: "body-single-line-md" + (selectedPage === 0 && '-bold'),
              color: selectedPage === 0 && BLUE_500
            })
          })), _jsx(Typography, {
            style: [paginationStyles.singlePage, paginationStyles.multiPages],
            selectable: false,
            text: "...",
            type: "body-single-line-md",
            color: BLACK_500
          })]
        }), getArrayWithRange(pageCount, selectedPage > pageNumbers.length - maxNumberOfPagesToBeShown ? pageNumbers.length - maxNumberOfPagesToBeShown : selectedPage, selectedPage + maxNumberOfPagesToBeShown).map((item, index) => {
          var isSelected = pageNumbers[selectedPage] === item;
          return _jsx(Pressable, Object.assign({
            style: paginationStyles.singlePage,
            onPress: () => {
              var _index = pageNumbers.findIndex(_item => _item == item);
              onPageSelectHandler(_index);
            }
          }, {
            children: _jsx(Typography, {
              selectable: false,
              text: item === null || item === void 0 ? void 0 : item.toString(),
              type: "body-single-line-md" + (isSelected && '-bold'),
              color: isSelected && BLUE_500
            })
          }), "single_page_" + index);
        }), selectedPage + maxNumberOfPagesToBeShown < pageCount && pageNumbers.length > maxNumberOfPagesToBeShown && _jsxs(_Fragment, {
          children: [_jsx(Typography, {
            style: [paginationStyles.singlePage, paginationStyles.multiPages],
            selectable: false,
            text: "...",
            type: "body-single-line-md",
            color: BLACK_500
          }), _jsx(Pressable, Object.assign({
            style: paginationStyles.singlePage,
            onPress: () => {
              onPageSelectHandler(pageNumbers.length - 1);
            }
          }, {
            children: _jsx(Typography, {
              selectable: false,
              text: (_b = pageNumbers[pageNumbers.length - 1]) === null || _b === void 0 ? void 0 : _b.toString(),
              type: "body-single-line-md" + (selectedPage === pageNumbers.length - 1 && '-bold'),
              color: selectedPage === pageNumbers.length - 1 && BLUE_500
            })
          }))]
        })]
      })), _jsx(Pressable, Object.assign({
        disabled: isLastPage,
        onPress: () => {
          onPageSelectHandler(selectedPage + 1);
        }
      }, {
        children: _jsx(RightChevronIcon, {
          fontSize: 20,
          color: isLastPage ? BLACK_500 : BLACK
        })
      })), _jsx(Pressable, Object.assign({
        disabled: isLastPage,
        onPress: () => onPageSelectHandler(pageNumbers.length - 1)
      }, {
        children: _jsx(RightDoubleChevronIcon, {
          fontSize: 20,
          color: isLastPage ? BLACK_500 : BLACK
        })
      }))]
    }))]
  }));
};